import { render } from "./DadosSorte.vue?vue&type=template&id=887cf528"
import script from "./DadosSorte.vue?vue&type=script&lang=js"
export * from "./DadosSorte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__